import { Navigate } from "react-router-dom";

function ProtectedCustomerRoute({ children }) {
  const customerEmail = localStorage.getItem("customerEmail");

  if (!customerEmail) {
    return <Navigate to="/customer-login" replace />;
  }

  return children;
}

export default ProtectedCustomerRoute;